/* ==========================================================================
   KINGBINK · Outfit — núcleo: modos, scroll, cursor, transición de página
   Sin dependencias. Respeta prefers-reduced-motion y desactiva el cursor
   personalizado en pantallas táctiles.
   ========================================================================== */
(function () {
  'use strict';

  var d = document, root = d.documentElement, w = window;
  var KB = w.KB = w.KB || {};
  var feats = (root.getAttribute('data-kb') || '').split(/\s+/);
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!KB.designMode;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var motion = feats.indexOf('motion') > -1 && !reduce;
  var cursorOn = feats.indexOf('cursor') > -1 && fine && !reduce && !design;
  var flipOn = feats.indexOf('flip') > -1 && !reduce && !design;

  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var store = {
    get: function (k) { try { return w.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { w.sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Bucle de animación compartido ---------- */
  var tasks = [], running = false, lastT = 0, idleUntil = 0;
  function wake(ms) {
    idleUntil = Math.max(idleUntil, performance.now() + (ms || 1400));
    if (!running) { running = true; lastT = performance.now(); w.requestAnimationFrame(loop); }
  }
  function loop(t) {
    var dt = Math.min(48, t - lastT); lastT = t;
    var busy = false;
    for (var i = 0; i < tasks.length; i++) { if (tasks[i](t, dt)) busy = true; }
    if (busy || t < idleUntil) w.requestAnimationFrame(loop); else running = false;
  }
  KB.wake = wake;

  /* ---------- Bloqueo del scroll (menús, bolsa, filtros) ---------- */
  var locks = 0;
  KB.lock = function (on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    root.classList.toggle('kb-lock', locks > 0);
  };

  /* ---------- Modo de color: Negro / Cement / Off White ---------- */
  function setMode(m, persist) {
    root.setAttribute('data-mode', m);
    $$('[data-kb-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kb-mode') === m ? 'true' : 'false'); });
    var meta = $('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', m === 'off' ? '#ebebeb' : m === 'cement' ? '#414147' : '#000000');
    if (persist) { try { w.localStorage.setItem('kb-mode', m); } catch (e) {} }
  }
  setMode(root.getAttribute('data-mode') || 'negro', false);
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kb-mode]');
    if (b) setMode(b.getAttribute('data-kb-mode'), true);
  });

  /* ---------- Alto del encabezado (variable CSS) ----------
     El grupo del encabezado puede tener varias secciones (encabezado y cinta de frases): todas quedan
     pegadas arriba una bajo la otra, en el orden del grupo, y --header-h es la suma de sus alturas. */
  KB.headerH = 0;
  var hdrWraps = [], hdrRO = null;
  function measureHeader() {
    var acc = 0;
    hdrWraps.forEach(function (el, i) {
      el.style.top = acc + 'px';
      el.style.zIndex = String(100 - i);
      acc += el.offsetHeight;
    });
    KB.headerH = acc;
    root.style.setProperty('--header-h', acc + 'px');
  }
  function scanHeader() {
    hdrWraps = $$('.shopify-section-group-header-group');
    if (hdrRO) hdrRO.disconnect();
    if ('ResizeObserver' in w) { hdrRO = new w.ResizeObserver(measureHeader); hdrWraps.forEach(function (el) { hdrRO.observe(el); }); }
    measureHeader();
  }
  scanHeader();
  w.addEventListener('resize', measureHeader);
  d.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.classList && e.target.classList.contains('shopify-section-group-header-group')) scanHeader(); });

  /* ---------- Menú móvil y búsqueda ---------- */
  var overlays = { menu: $('[data-kb-menu]'), search: $('[data-kb-search]') };
  function openOverlay(name) {
    var el = overlays[name]; if (!el) return;
    closeOverlays();
    el.hidden = false; KB.lock(true);
    $$('[data-kb-' + name + '-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('input, a, button', el); if (name === 'search') { var i = $('input[type="search"]', el); if (i) i.focus(); }
  }
  function closeOverlays() {
    Object.keys(overlays).forEach(function (n) {
      var el = overlays[n]; if (!el || el.hidden) return;
      el.hidden = true; KB.lock(false);
      $$('[data-kb-' + n + '-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kb-menu-toggle], [data-kb-search-toggle]');
    if (!t) return;
    var name = t.hasAttribute('data-kb-menu-toggle') ? 'menu' : 'search';
    var el = overlays[name];
    if (el && !el.hidden) closeOverlays(); else openOverlay(name);
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOverlays(); });

  /* ---------- Revelado al entrar en pantalla ---------- */
  var revealIO = null;
  if (motion && 'IntersectionObserver' in w) {
    revealIO = new w.IntersectionObserver(function (entries) {
      var k = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.style.transitionDelay = (k++ * 85) + 'ms';
        el.classList.add('is-in');
        revealIO.unobserve(el);
        w.setTimeout(function () { el.style.transitionDelay = ''; }, 1800);
      });
    }, { threshold: .08, rootMargin: '0px 0px -4% 0px' });
  }

  /* ---------- Scrub: variables --p / --e según la posición en pantalla ---------- */
  var scrubs = [];
  var scrubIO = 'IntersectionObserver' in w ? new w.IntersectionObserver(function (entries) {
    entries.forEach(function (en) { en.target.__kbVis = en.isIntersecting; });
    wake();
  }, { rootMargin: '25% 0px 25% 0px' }) : null;

  function splitWords(el) {
    if (el.__kbSplit) return; el.__kbSplit = true;
    var words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.textContent = '';
    words.forEach(function (word, i) {
      var s = d.createElement('span');
      s.className = 'w'; s.style.setProperty('--i', i); s.textContent = word; s.setAttribute('aria-hidden', 'true');
      el.appendChild(s);
      if (i < words.length - 1) el.appendChild(d.createTextNode(' '));
    });
    el.style.setProperty('--n', words.length);
  }

  function scrubUpdate() {
    if (!scrubs.length) return false;
    var h = w.innerHeight, hdr = KB.headerH || 0;
    var rects = [], i, s, r;
    for (i = 0; i < scrubs.length; i++) {
      s = scrubs[i];
      if (!s.el.isConnected) { scrubs.splice(i--, 1); continue; }
      if (scrubIO && !s.el.__kbVis) { rects.push(null); continue; }
      rects.push(s.el.getBoundingClientRect());
      if (s.mode === 'cover') {
        var wrap = s.el.closest('.shopify-section') || s.el, nx = wrap.nextElementSibling;
        s.nxTop = nx ? nx.getBoundingClientRect().top : null;
      }
    }
    for (i = 0; i < scrubs.length; i++) {
      r = rects[i]; if (!r) continue; s = scrubs[i];
      var p;
      if (s.mode === 'cover') p = s.nxTop == null ? 0 : clamp((r.bottom - s.nxTop) / Math.max(1, r.height), 0, 1);
      else if (s.mode === 'pin') p = clamp((hdr - r.top) / Math.max(1, r.height - (h - hdr)), 0, 1);
      else if (s.mode === 'words') p = clamp((h * .9 - r.top) / (r.height + h * .42), 0, 1);
      else p = clamp((h - r.top) / (h + r.height), 0, 1);
      if (Math.abs(p - s.last) < .0006) continue;
      s.last = p;
      s.el.style.setProperty('--p', p.toFixed(4));
      if (s.mode === 'pin') s.el.style.setProperty('--e', ease(p).toFixed(4));
      else if (s.mode === 'cover') s.el.style.setProperty('--e', p.toFixed(4));
    }
    return false;
  }

  /* ---------- Parallax suave ---------- */
  var plx = [];
  function parallaxUpdate() {
    if (!plx.length) return;
    var h = w.innerHeight, rects = [], i;
    for (i = 0; i < plx.length; i++) rects.push(plx[i].getBoundingClientRect());
    for (i = 0; i < plx.length; i++) {
      var r = rects[i]; if (r.bottom < -200 || r.top > h + 200) continue;
      var f = parseFloat(plx[i].getAttribute('data-kb-parallax')) || 0;
      plx[i].style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - h / 2) * f).toFixed(1) + 'px,0)';
    }
  }

  /* ---------- Cinta de frases (velocidad y dirección según el scroll) ---------- */
  var marquees = [];
  function initMarquee(el) {
    var track = $('[data-kb-track]', el), g = $('[data-kb-group]', el);
    if (!track || !g) return;
    var gw = g.getBoundingClientRect().width || 1;
    var copies = Math.ceil(w.innerWidth / gw) + 1;
    for (var i = 0; i < copies; i++) { var c = g.cloneNode(true); c.removeAttribute('data-kb-group'); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); }
    var m = { el: el, track: track, gw: gw, x: 0, speed: parseFloat(el.getAttribute('data-speed')) || 60, dir: 1, sk: 0, vis: true };
    marquees.push(m);
    if ('IntersectionObserver' in w) new w.IntersectionObserver(function (es) { m.vis = es[0].isIntersecting; wake(); }).observe(el);
    w.addEventListener('resize', function () { m.gw = g.getBoundingClientRect().width || m.gw; });
  }
  function marqueeUpdate(dt, vel, dir) {
    var any = false;
    marquees.forEach(function (m) {
      if (!m.vis) return;
      any = true;
      m.dir += (dir - m.dir) * .06;
      var v = (m.speed + Math.abs(vel) * 16) * m.dir;
      m.x -= v * dt / 1000;
      m.x = ((m.x % m.gw) + m.gw) % m.gw - m.gw;
      var sk = clamp(vel * -.35, -9, 9); m.sk += (sk - m.sk) * .15;
      m.track.style.transform = 'translate3d(' + m.x.toFixed(1) + 'px,0,0)';
      m.track.style.setProperty('--sk', m.sk.toFixed(2));
    });
    return any;
  }

  /* ---------- Cursor: sombrero de paja de Luffy ----------
     Siempre el mismo símbolo. En reposo es pequeño (--cursor-size) y crece
     solo cuando hay algo con lo que interactuar. */
  var cur = null;
  if (cursorOn) {
    var curEl = $('[data-kb-cursor]');
    if (curEl) {
      var symWrap = $('.kb-cursor__sym', curEl), label = $('[data-kb-cursor-label]', curEl);
      cur = { el: curEl, x: -200, y: -200, tx: -200, ty: -200, rot: 0, sc: 1, tsc: 1, pulse: 0, shown: false, state: '' };

      var STATES = {
        '': { s: 1, l: '' }, link: { s: 1.7, l: '' }, view: { s: 2.3, l: 'Ver' }, drag: { s: 2.1, l: 'Arrastra' },
        zoom: { s: 2.1, l: 'Zoom' }, add: { s: 1.9, l: 'Agregar' }, close: { s: 1.8, l: 'Cerrar' }, hide: { s: 0, l: '' }
      };
      var setState = function (name) {
        if (name === cur.state) return;
        cur.state = name;
        var st = STATES[name] || STATES[''];
        cur.tsc = st.s;
        label.textContent = st.l;
        curEl.classList.toggle('has-label', !!st.l);
        curEl.classList.toggle('is-hidden', name === 'hide');
        wake();
      };
      d.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        cur.tx = e.clientX; cur.ty = e.clientY;
        if (!cur.shown) { cur.shown = true; cur.x = cur.tx; cur.y = cur.ty; root.classList.add('kb-cursor-on'); }
        curEl.classList.add('is-visible');
        tiltMove(e); wake();
      }, { passive: true });
      d.addEventListener('mouseover', function (e) {
        var t = e.target; if (!t || !t.closest) return;
        var c = t.closest('[data-cursor]');
        if (c) return setState(c.getAttribute('data-cursor'));
        if (t.closest('input, textarea, select, [contenteditable="true"]')) return setState('hide');
        if (t.closest('a, button, summary, label, [role="button"]')) return setState('link');
        setState('');
      });
      d.addEventListener('pointerdown', function () { cur.pulse = 1; wake(); });
      d.addEventListener('mouseout', function (e) { if (!e.relatedTarget) curEl.classList.remove('is-visible'); });
      tasks.push(function () {
        var dx = cur.tx - cur.x, dy = cur.ty - cur.y;
        cur.x += dx * .24; cur.y += dy * .24;
        cur.rot = lerp(cur.rot, clamp(dx * .9, -32, 32), .18);
        cur.pulse *= .88; if (cur.pulse < .01) cur.pulse = 0;
        var target = cur.tsc * (1 + Math.min(.22, Math.hypot(dx, dy) / 160)) * (1 - cur.pulse * .28);
        cur.sc = lerp(cur.sc, target, .22);
        curEl.style.transform = 'translate3d(' + cur.x.toFixed(1) + 'px,' + cur.y.toFixed(1) + 'px,0)';
        symWrap.style.setProperty('--rot', cur.rot.toFixed(2) + 'deg');
        symWrap.style.setProperty('--sc', cur.sc.toFixed(3));
        return Math.abs(dx) > .15 || Math.abs(dy) > .15 || Math.abs(cur.rot) > .2 || Math.abs(cur.sc - target) > .004 || cur.pulse > 0;
      });
    }
  }

  /* ---------- Inclinación 3D de las fichas ---------- */
  var tiltEl = null;
  function tiltReset(m) { m.classList.remove('is-tilting'); m.style.setProperty('--tx', 0); m.style.setProperty('--ty', 0); }
  function tiltMove(e) {
    var m = e.target.closest ? e.target.closest('[data-kb-tilt]') : null;
    if (m !== tiltEl) { if (tiltEl) tiltReset(tiltEl); tiltEl = m; if (m) m.classList.add('is-tilting'); }
    if (!m) return;
    var r = m.getBoundingClientRect();
    m.style.setProperty('--tx', ((clamp((e.clientX - r.left) / r.width, 0, 1) - .5) * 2).toFixed(3));
    m.style.setProperty('--ty', ((clamp((e.clientY - r.top) / r.height, 0, 1) - .5) * 2).toFixed(3));
  }
  if (fine && !reduce && !cursorOn) {
    d.addEventListener('pointermove', function (e) { if (!e.pointerType || e.pointerType === 'mouse') tiltMove(e); }, { passive: true });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnetic(el) {
    if (!fine || reduce || el.__kbMag) return; el.__kbMag = true;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - (r.left + r.width / 2)) * .22, y = (e.clientY - (r.top + r.height / 2)) * .3;
      el.style.transition = 'transform .12s linear';
      el.style.transform = 'translate3d(' + clamp(x, -12, 12).toFixed(1) + 'px,' + clamp(y, -9, 9).toFixed(1) + 'px,0)';
    });
    el.addEventListener('pointerleave', function () {
      el.style.transition = 'transform .7s cubic-bezier(.34,1.56,.64,1)';
      el.style.transform = '';
    });
  }

  /* ---------- Lista de categorías: vista previa que sigue al cursor ---------- */
  function initCats(sec) {
    if (!fine || reduce || sec.__kbCats) return; sec.__kbCats = true;
    var rows = $$('[data-kb-cat]', sec), prev = $('[data-kb-cats-preview]', sec), pvs = $$('[data-kb-pv]', sec);
    if (!prev || !rows.length) return;
    var st = { x: 0, y: 0, tx: 0, ty: 0, rot: 0, active: -1, fresh: true };
    function setActive(n) {
      st.active = n;
      pvs.forEach(function (p, k) { p.classList.toggle('is-on', k === n); });
      prev.classList.toggle('is-on', n >= 0);
      if (n >= 0 && st.fresh) { st.x = st.tx; st.y = st.ty; st.fresh = false; }
      if (n < 0) st.fresh = true;
      wake();
    }
    rows.forEach(function (r) {
      r.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { st.tx = e.clientX; st.ty = e.clientY; setActive(+r.getAttribute('data-kb-cat')); } });
      r.addEventListener('pointerleave', function () { setActive(-1); });
    });
    sec.addEventListener('pointermove', function (e) { st.tx = e.clientX; st.ty = e.clientY; wake(); }, { passive: true });
    tasks.push(function () {
      if (!sec.isConnected) return false;
      if (st.active < 0 && !prev.classList.contains('is-on')) return false;
      var dx = st.tx - st.x, dy = st.ty - st.y;
      st.x += dx * .14; st.y += dy * .14;
      st.rot = lerp(st.rot, clamp(dx * .07, -12, 12), .12);
      prev.style.transform = 'translate3d(' + (st.x + 26).toFixed(1) + 'px,' + st.y.toFixed(1) + 'px,0) rotate(' + st.rot.toFixed(2) + 'deg)';
      return st.active >= 0 || Math.abs(dx) > .3 || Math.abs(dy) > .3;
    });
  }

  /* ---------- Riel horizontal: arrastrar con el mouse y barra de avance ---------- */
  function initRail(rail) {
    if (rail.__kbRail) return; rail.__kbRail = true;
    var bar = rail.parentElement ? $('[data-kb-rail-bar]', rail.parentElement) : null;
    function upd() {
      if (!bar) return;
      var max = rail.scrollWidth - rail.clientWidth, wv = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
      bar.style.setProperty('--w', clamp(wv, .05, 1).toFixed(3));
      bar.style.setProperty('--x', (max > 0 ? (rail.scrollLeft / max) * (1 - wv) : 0).toFixed(3));
    }
    rail.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', upd); upd();
    var down = false, sx = 0, sl = 0, moved = 0;
    rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; sx = e.clientX; sl = rail.scrollLeft; moved = 0; });
    w.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
      if (moved > 6) { rail.classList.add('is-dragging'); rail.scrollLeft = sl - dx; }
    });
    w.addEventListener('pointerup', function () { if (!down) return; down = false; w.setTimeout(function () { rail.classList.remove('is-dragging'); }, 0); });
    rail.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
  }

  /* ---------- Acordeones con altura animada ---------- */
  d.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('summary');
    if (!sum) return;
    var det = sum.parentElement;
    if (!det || !det.hasAttribute('data-kb-acc')) return;
    e.preventDefault();
    var body = $('.kb-acc__body, .kb-fil__body', det);
    if (!body || reduce) { det.open = !det.open; return; }
    var opts = { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' };
    if (det.open) {
      var h = body.offsetHeight;
      var a = body.animate([{ height: h + 'px' }, { height: '0px' }], opts);
      a.onfinish = function () { det.open = false; };
    } else {
      det.open = true;
      var h2 = body.offsetHeight;
      body.animate([{ height: '0px' }, { height: h2 + 'px' }], opts);
    }
  });

  /* ---------- Transición de página (giro) ---------- */
  var flip = $('[data-kb-flip]');
  var flipping = false;
  function flipTo(url) {
    if (!flip || flipping) { w.location.href = url; return; }
    flipping = true;
    store.set('kb-flip', '1');
    flip.classList.remove('is-out', 'is-instant');
    flip.classList.add('is-active');
    void flip.offsetWidth;
    flip.classList.add('is-in');
    w.setTimeout(function () { w.location.href = url; }, 780);
    w.setTimeout(function () { flipping = false; flip.classList.remove('is-in', 'is-active'); }, 3200);
  }
  KB.flipTo = flipTo;
  if (flip && flipOn) {
    // Si llegamos desde una transición, se abre el telón.
    if (root.classList.contains('kb-flip-cover')) {
      flip.classList.add('is-active', 'is-in', 'is-instant');
      void flip.offsetWidth;
      root.classList.remove('kb-flip-cover');
      w.requestAnimationFrame(function () {
        flip.classList.remove('is-instant');
        flip.classList.remove('is-in');
        flip.classList.add('is-out');
        w.setTimeout(function () { flip.classList.remove('is-active', 'is-out'); }, 1000);
      });
    }
    d.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-kb-noflip')) return;
      if (a.origin !== w.location.origin) return;
      var path = a.pathname;
      if (/^\/(checkouts?|cart\/(add|change)|account\/logout)/.test(path) || /^\/\d+\/(checkouts|orders)/.test(path)) return;
      if (a.hasAttribute('data-kb-cart-toggle')) return;
      if (a.pathname === w.location.pathname && a.search === w.location.search) return;
      e.preventDefault();
      flipTo(a.href);
    });
    w.addEventListener('pageshow', function (e) {
      if (e.persisted) { flipping = false; flip.classList.remove('is-in', 'is-out', 'is-active', 'is-instant'); }
    });
  } else if (root.classList.contains('kb-flip-cover')) {
    root.classList.remove('kb-flip-cover');
  }

  /* ---------- Portada: la línea marcada con data-kb-fit cubre el ancho de borde a borde ----------
     Se mide la caja a 100px y se descuentan los márgenes laterales de la primera y la última letra
     (DM Sans Black: .045em y .035em) y el espaciado negativo final (.03em). */
  function fitHero(h) {
    var t = $('.kb-hero__title', h), l = $('[data-kb-fit] > span', h);
    if (!t || !l) return;
    var cs = w.getComputedStyle(t), avail = h.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    h.__kbW = h.clientWidth;
    if (avail <= 0) return;
    t.style.setProperty('--hero-fs', '100px');
    var em = l.getBoundingClientRect().width / 100;
    if (!em) return;
    t.style.setProperty('--hero-fs', (avail / (em + .03 - .045 - .035)).toFixed(2) + 'px');
  }

  /* ---------- Escaneo de contenido (también para secciones recargadas) ---------- */
  function scan(scope) {
    scope = scope || d;
    $$('[data-kb-reveal]:not(.is-in)', scope).forEach(function (el) {
      if (el.__kbR) return; el.__kbR = true;
      if (revealIO) revealIO.observe(el); else el.classList.add('is-in');
    });
    $$('[data-kb-words]', scope).forEach(function (el) { if (motion) splitWords(el); });
    $$('[data-kb-scrub]', scope).forEach(function (el) {
      if (el.__kbS || !motion) return; el.__kbS = true;
      var mode = el.getAttribute('data-kb-scrub') || 'view';
      scrubs.push({ el: el, mode: mode, last: -1 });
      if (scrubIO) scrubIO.observe(el);
    });
    $$('[data-kb-parallax]', scope).forEach(function (el) { if (motion && plx.indexOf(el) < 0) plx.push(el); });
    $$('[data-kb-marquee]', scope).forEach(function (el) { if (motion && !el.__kbM) { el.__kbM = true; initMarquee(el); } });
    $$('[data-kb-magnetic]', scope).forEach(initMagnetic);
    $$('[data-kb-cats]', scope).forEach(initCats);
    $$('[data-kb-rail]', scope).forEach(initRail);
    $$('[data-kb-hero]', scope).forEach(function (h) {
      if (h.__kbH) return; h.__kbH = true;
      fitHero(h);
      var go = function () { fitHero(h); h.classList.add('is-ready'); };
      if (d.fonts && d.fonts.ready) { d.fonts.ready.then(function () { w.setTimeout(go, 60); }); w.setTimeout(go, 1600); } else go();
      if ('ResizeObserver' in w) new w.ResizeObserver(function () { if (h.clientWidth !== h.__kbW) fitHero(h); }).observe(h);
    });
    wake();
  }
  KB.scan = scan;

  /* ---------- Tarea de scroll ---------- */
  var sy = w.scrollY, vel = 0, dir = 1;
  if (motion || cur) {
    w.addEventListener('scroll', function () { wake(); }, { passive: true });
    w.addEventListener('resize', function () { wake(); });
    tasks.push(function (t, dt) {
      var y = w.scrollY, dy = y - sy; sy = y;
      if (dy) dir = dy > 0 ? 1 : -1;
      vel += (dy - vel) * .16; if (Math.abs(vel) < .04) vel = 0;
      scrubUpdate(); parallaxUpdate();
      var m = marqueeUpdate(dt, vel, dir);
      return m || Math.abs(vel) > .08;
    });
  }

  function boot() { scan(d); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
